var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// ./~/ics/~/moment-timezone/index.js
// module id = 1052
// module chunks = 0